import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { PageTitleService } from './page-title.service';

/**
 * Sets the document title for routes that declare a `title` translation key
 * (e.g. `pageTitle.login`), re-applied on language change. Module routes
 * (`data: { moduleCode }`) are handled by ModuleTitleService; the AngularJS
 * catch-all sets its own title.
 */
@Injectable()
export class CipoTitleStrategy extends TitleStrategy {
  private readonly translate = inject(TranslateService);
  private readonly pageTitle = inject(PageTitleService);

  private lastSnapshot: RouterStateSnapshot = null;

  constructor() {
    super();
    this.translate.onLangChange.subscribe(() => this.applyTitle());
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.lastSnapshot = snapshot;
    this.applyTitle();
  }

  private applyTitle(): void {
    const titleKey = this.lastSnapshot ? this.buildTitle(this.lastSnapshot) : undefined;
    if (titleKey) {
      this.pageTitle.setPageTitle(this.translate.instant(titleKey));
    }
  }
}
